import { Card } from '@mui/material';

import { ReferralClaim, ReferralInfo } from './referral-dashboard';

export const ReferralControl = () => {
  return (
    <Card sx={{ flex: 1, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, padding: 3, gap: 3 }}>
      <ReferralInfo />
      <ReferralClaim />
    </Card>
  );
};
